var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You do not need to install or authorize the iU Community Onboarding Monday.com app. If you have any questions, please reach out to the iU web dev team.")])}
var staticRenderFns = []

export { render, staticRenderFns }